import { render, staticRenderFns } from "./checkTheList.vue?vue&type=template&id=48fbe092&scoped=true"
import script from "./checkTheList.vue?vue&type=script&lang=js"
export * from "./checkTheList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbe092",
  null
  
)

export default component.exports